const STORAGE_KEY = 'sharetime_browsing_history';
const MAX_ENTRIES = 10;

/** Record a property view in local browsing history (most recent first, deduped). */
export function recordPropertyView(property) {
  if (!property?.id) return;
  const existing = getBrowsingHistory().filter(p => p.id !== property.id);
  const entry = {
    id: property.id,
    slug: property.slug,
    name: property.name,
    location: property.location,
    image: property.image_urls?.[0] || null,
    viewedAt: new Date().toISOString(),
  };
  const next = [entry, ...existing].slice(0, MAX_ENTRIES);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // localStorage unavailable — ignore
  }
}

/** Return recently viewed properties, most recent first. */
export function getBrowsingHistory() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}
